export const classes = {
  button:
    'mt-2 mb-3 text-grey-8 dark:text-mauve-1 text-base place-start cursor-pointer py-2 px-2 bg-transparent rounded-lg hover:bg-grey-3 dark:hover:bg-white/[0.1] transition-colors outline-none',
  label: 'mx-2 text-base font-medium',
};
